import Features from "./Services";
import Footer from "./Footer";
import Header from "./Header";
import "./Home.css";
import Services from "./Services";
import Slider from "./Slider";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>Home - Travel Management</title>
      </Helmet>
      <Header />
      <Services />
      <Slider />
    </div>
  );
};

export default Home;
